import type { insuranceMonitorApiSpec } from "@wingspanhq/wingspan-api-types";
import { useWSMutation } from "../../helpers";
import { setCoverageOnInsuranceCoverageMonitor } from "../../../services/api/insurance/monitor/setCoverageOnInsuranceCoverageMonitor";
import { QUERY_INSURANCE_COVERAGE_MONITOR } from "../queries/useQueryInsuranceCoverageMonitor";

type InsuranceCoverageMonitor =
  insuranceMonitorApiSpec.InsuranceCoverageMonitor;
type SetCoverageOnInsuranceCoverageMonitorRequest =
  insuranceMonitorApiSpec.operations["setCoverageOnInsuranceCoverageMonitor"]["requestBody"]["content"]["application/json"];

type UseSetCoverageOnInsuranceCoverageMonitorProps =
  SetCoverageOnInsuranceCoverageMonitorRequest & {
    insuranceCoverageMonitorId: string;
  };

export const useMutationSetCoverageOnInsuranceCoverageMonitor = () => {
  return useWSMutation<
    InsuranceCoverageMonitor,
    unknown,
    UseSetCoverageOnInsuranceCoverageMonitorProps
  >(
    async ({
      insuranceCoverageMonitorId,
      ...request
    }: UseSetCoverageOnInsuranceCoverageMonitorProps) => {
      return await setCoverageOnInsuranceCoverageMonitor(
        insuranceCoverageMonitorId,
        request
      );
    },
    {
      dependencies: [QUERY_INSURANCE_COVERAGE_MONITOR]
    }
  );
};
